import { Settings, useSettingManager } from "../../hooks/useSettingManager"
import { ExternalOrganizationConcessionOrganizationUsersProps } from "../../types/types"
import ConcessionOrganizationUsers from "../ConcessionOrganizationUsers/ConcessionOrganizationUsers"

export default function ExecutingOrganizationConcessionOrganizationUsers(props: ExternalOrganizationConcessionOrganizationUsersProps) {
    const { organization, onDeleteConcessionOrganizationUser, organizationStore } = props
    const title = "Colaboradores Entidade Executante"
    const getSetting = useSettingManager()
    const organizationTypeId = getSetting(Settings.EXECUTING_ORGANIZATION_TYPE_ID)

    return (
        <ConcessionOrganizationUsers
            title={title}
            organizationTypeId={organizationTypeId}
            organization={organization}
            onDeleteConcessionOrganizationUser={onDeleteConcessionOrganizationUser}
            organizationStore={organizationStore}
        />
    )
}
